import { Controller } from "react-hook-form";
import Select from "react-select";
import { Col, FormFeedback, Input, Label, Row } from "reactstrap";
import InputField from "../../../../components/layout/InputField";
import { PLACEMENT_TYPE } from "../../../../utils/constant";
import { AppContext } from "../../../../context";
import { useContext } from "react";

export default function BasicDetailsStepOne({
  control,
  setPlacementType,
  register,
  readonly,
  errors,
  disableAllFields,
  placementId,
  placementEndDate,
  loadingAgreements,
  agreements,
  placementType
}: any) {
  const { theme } = useContext(AppContext);
  const customStyles = {
    control: (styles, provided) => ({
      ...styles,

      backgroundColor: theme === "light" ? provided.background : "#282828",
      borderColor: theme === "light" ? "#ced4da" : "#525252",
      color: theme === "light" ? provided.backgroundColor : "#d9d9d9",
      fontSize: 12,
      "&:hover": {
        borderColor: theme === "light" ? "#ced4da" : "#282828",
        color: theme === "light" ? provided.background : "#d9d9d9",
      },
    }),
    menu: (provided) => ({
      ...provided,
      background: theme === "light" ? provided.background : "#282828",
      color: theme === "light" ? provided.background : "#d9d9d9",
    }),
    option: (provided) => ({
      ...provided,
      fontSize: 12,
      background: theme === "light" ? provided.background : "#363636",
      "&:hover": {
        background: theme === "light" ? provided.background : "#474444",
        color: theme === "light" ? provided.background : "#d9d9d9",
      },
    }),
    container: (provided, state) => ({
      ...provided,
      fontSize: 12,
    }),
  };

  return (
    <Row>
      <Col lg="4" md="6" sm="12">
        <Label>Placement ID</Label>
        <Input
          readOnly={readonly}
          disabled={true}
          label="Placement ID"
          inputtype="text"
          defaultValue={placementId}

        />
      </Col>
      <Col lg="4" md="6" sm="12" className="agreementSelectSpacing">
        <Label>
          Start Date<span className="text-danger">*</span>
        </Label>
        <Controller
          control={control}
          name="startDate"
          rules={{
            required: "Start date is required!",
          }}
          render={({ field, fieldState }) => (
            <>
              <Input
                {...field}
                readOnly={readonly}
                disabled={disableAllFields}
                min={new Date().toISOString().substring(0, 10)}
                type="date"
                invalid={!!fieldState.error}
                value={field.value || ""}
              />
              {fieldState.error && (
                <FormFeedback>{fieldState.error.message}</FormFeedback>
              )}
            </>
          )}
        />
      </Col>

      {!!placementType && placementType?.value === 'CONTRACT' &&
        <Col lg="4" md="6" sm="12" className="agreementSelectSpacing">
          <Label>
            End Date<span className="text-danger">*</span>
          </Label>
          <Controller
            control={control}
            name="placementEndDate"
            render={({ field, fieldState }) => (
              <>
                <Input
                  {...field}
                  readOnly={readonly}
                  disabled={true}
                  min={new Date().toISOString().substring(0, 10)}
                  type="date"
                  invalid={!!fieldState.error}
                  value={field.value || ""}
                />
                {fieldState.error && (
                  <FormFeedback>{fieldState.error.message}</FormFeedback>
                )}
              </>
            )}
          />
        </Col>}

      <Col lg="4" md="6" sm="12" className="displayNoneHeading">
        <Label>
          Placement Source
          <span className="text-danger">*</span>
        </Label>
        <Controller
          control={control}
          name="placementSource"
          rules={{
            required: "Placement source is required!",
          }}
          render={({ field, fieldState }) => (
            <>
              <InputField
                {...field}
                readOnly={readonly}
                disabled={disableAllFields}
                label=""
                isRequired
                inputtype="text"
                className="m-0"
                placeholder="Placement Source"
                inputid="placementSource"
                errMsg={fieldState.error?.message}
              />
            </>
          )}
        />

        <div className="d-flex flex-column">
          <small className="text-info">Example: “LinkedIn or Referral”.</small>
        </div>
      </Col>

      <Col lg="4" md="6" sm="12" className="agreementSelectSpacing">
        <Label>
          Placement Type <span className="text-danger">*</span>
        </Label>
        <Controller
          rules={{
            required: {
              value: true,
              message: "Placement type must be selected!",
            },
          }}
          name="placementType"
          render={({ field: { onChange, name, value, ref } }) => (
            <Select
              isDisabled={disableAllFields || readonly}
              onChange={(e) => {
                setPlacementType(e);
                onChange(e);
              }}
              value={value}
              name={name}
              ref={ref}
              options={PLACEMENT_TYPE?.map((item: any) => {
                return {
                  label: item?.label,
                  value: item?.value,
                };
              })}
              styles={customStyles}
            />
          )}
          control={control}
        />
        {errors?.placementType && (
          <small className="text-danger">{errors.placementType.message}</small>
        )}
      </Col>

      {placementType?.value === 'CONTRACT' && <Col lg="4" md="4" sm="12" className="agreementSelectSpacing">
        <Label>
          Temp Agreement
        </Label>
        <Controller
          rules={{
            required: false,
          }}
          name="agreement"
          render={({ field: { onChange, name, value, ref } }) => (
            <Select
              isDisabled={disableAllFields || readonly}
              isLoading={loadingAgreements}
              onChange={(e) => {
                // onAgreementFilling(e);
                onChange(e);
              }}
              value={value?.value ? value : null}
              name={name}
              ref={ref}
              styles={customStyles}
              options={agreements?.map((item: any) => {
                return {
                  label: item?.nickName,
                  value: item?.id,
                };
              })}
            />
          )}
          control={control}
        />
        {errors?.agreement && (
          <small className="text-danger">{errors.agreement.message}</small>
        )}
      </Col>}
    </Row>
  );
}
